import { createBrowserRouter, Navigate } from "react-router-dom";
import { ROUTES } from "./routes";
import GlobalLoader from "../components/GlobalLoader";
import { lazy } from "react";
import PrivateRoute from "../components/PrivateRoute";
import RootLayout from "../components/RootLayout";
import TermsAndConditions from "../pages/terms-and-conditions";
import ContactUs from "../pages/contact-us";
import PrivacyPolicy from "../pages/privacy-policy";
import TickerWindowExplanation from "../pages/ticker-window-explaination";
import CookiePolicy from "../pages/cookie-policy";
import Disclaimer from "../pages/disclaimer";

const HomePage = lazy(() => import("../pages"));

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        path: ROUTES.index,
        element: (
          <GlobalLoader>
            <HomePage />
          </GlobalLoader>
        ),
      },
      {
        path: ROUTES.contact_us.index,
        element: (
          <GlobalLoader>
            <ContactUs />
          </GlobalLoader>
        ),
      },
      {
        path: ROUTES.terms_and_condition.index,
        element: (
          <GlobalLoader>
            <TermsAndConditions />
          </GlobalLoader>
        ),
      },
      {
        path: ROUTES.privacy_policy.index,
        element: (
          <GlobalLoader>
            <PrivacyPolicy />
          </GlobalLoader>
        ),
      },
      {
        path: ROUTES.cookie_policy.index,
        element: (
          <GlobalLoader>
            <CookiePolicy />
          </GlobalLoader>
        ),
      },
      {
        path: ROUTES.disclaimer.index,
        element: (
          <GlobalLoader>
            <Disclaimer />
          </GlobalLoader>
        ),
      },
      {
        path: ROUTES.ticker_window_explanation.index,
        element: (
          <GlobalLoader>
            <TickerWindowExplanation />
          </GlobalLoader>
        ),
      },
      {
        path: ROUTES.wildCard,
        element: (
          <GlobalLoader>
            <PrivateRoute>
              <Navigate to="/" /> {/* Redirect to home or a custom 404 page */}
            </PrivateRoute>
          </GlobalLoader>
        ),
      },
    ],
  },
]);
